import { StackedCaseStudies } from "./stacked-case-studies";

// Mobile tree entry (<768): single-column stack grouped by industry.
export function CaseStudiesV2Mobile() {
  return (
    <section id="case-studies-mobile" className="mt-12 w-full px-2.5">
      <header className="mb-8 text-center">
        <h2 className="mb-4 font-body text-lg font-light text-foreground">
          CASE STUDIES
        </h2>
        <p className="font-heading text-3xl text-foreground">Selected Work</p>
      </header>
      <StackedCaseStudies columns={1} />
    </section>
  );
}
